import { AfterViewInit, Component } from '@angular/core';
import { ActionComponent } from '@ntap/core';

import { PrimeNGListActionBarComponent, SplitButtonItem } from '@ntap/primeng';
import { combineLatest, map, Observable, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-edit-actionbar',
  templateUrl: './edit-actionbar.component.html',
  styleUrls: ['./edit-actionbar.component.scss']
})
export class EditActionbarComponent
  extends PrimeNGListActionBarComponent
  implements AfterViewInit
{
  private filteredItems$: Observable<SplitButtonItem[]>;
  filteredItemsWithoutFirst$: Observable<SplitButtonItem[]>;
  filteredFirstAction$: Observable<SplitButtonItem>;

  override populateSplitButton(): void {
    const dynamicComponentsArr = this.dynamicComponents.toArray();

    const actionsObservables: Observable<any>[] = dynamicComponentsArr
      .filter((dynamicComponent) => !!dynamicComponent.getViewComponent())
      .map((dynamicComponent) => {
        const component = <ActionComponent>dynamicComponent.getViewComponent();
        return component.action$.pipe(
          switchMap((action) => {
            return component.isDisabled$.pipe(
              map((disabled) => {
                const description = action.description;
                return {
                  label: description,
                  command: (event: any) => {
                    component.executeAction(event);
                  },
                  disabled: disabled,
                  tooltip: action.tooltip,
                  icon: action.icon,
                  name: action.name
                };
              })
            );
          })
        );
      });

    this.items$ =
      actionsObservables.length > 0
        ? combineLatest(actionsObservables)
        : of([]);

    this.filteredItems$ = this.items$.pipe(
      map((i: SplitButtonItem[]) => {
        return i.filter((a) =>
          this.isActionToFilterOut(a as SplitButtonItem & { name: string })
        );
      })
    );
    this.filteredFirstAction$ = this.filteredItems$.pipe(map((i) => i[0]));
    this.filteredItemsWithoutFirst$ = this.filteredItems$.pipe(
      map((i) => ((i.length > 1 && i.slice(1)) || []) as SplitButtonItem[])
    );
  }

  private isActionToFilterOut(a: SplitButtonItem & { name: string }): unknown {
    return !(
      // TODO na hijerarhiji jos nismo prebacili na otvaranje preko naziva
      (
        this.viewProvider.viewName != 'jedinica_gradiva_hijerarhija' &&
        [
          'openAgent',
          'openJedinicaGradiva',
          'openArhivPosjednik',
          'dokumentacija_defaultItemView_readonly_action',
          'openMjesto',
          'openPlanRestauratorskihRadova'
        ].indexOf(a.name) >= 0
      )
    );
  }
}
